/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BicycleIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACIklEQVR4nO1USWsUURBut7jhQXP14NGfoCA2QUcG8mqZwJuqcSGeBm+K4gJGR/Qc8eIfEMVf4EFPgorLRRQFiaIRxZOIEgwR1EjNVM/0LJlJPAhCCh50v66vlq++6iRZtv/WkOQess63jnwD0uujo/s39wUC64N2oH4HltAjwXSHX/0A640lVqbzdtdVCOlkPSDpFXsPY5XtyPobSGeSJFmxKBpCCBuA9KsFsgBtCUrlHY0E8iELiCR3jYFksZam6WokmepFRf4EruxM/saQ9cig4A3e5fKSgxcKBzcCyadMIR5oLO9jlXuS9wN5r1ara5B1AlleOLefPegjZDnqz7d6zGim2QnpGyA9EWNcn3Q5dsvTFaRPSqUDW5F1Dkh/2nMruDxeAHM7xjjUTAAkl/zj28CVXchytWOJzgLpTX+fcMzpfKfI+hGxvNfocsz5VgLWd/VLLO8mkm2NauUXshx352eBZE9Gg2NeuYLSLKhJF0pa8N2Zyqtlzi6NOyA57BVdQ8RNWZW1Wm2l0WUzsoEC6axjhrKlqxfUxOhsLkFjsIjlkWKxuBZYK8ZxYNnn6//S/GKMqzK1ZF1bB8yHhoH0WIxxi9Nkgniem4Ge8ramzcF+WBbcttQ7ONepOmS9mMOMmKwNm2GQ5WTT2dpE0ocLKOJ+l+wGKk/u2F+gDeD8X0DW18jyxVo0TtPx8XX9d0fOAMtTIP1hWOu2H2bZ/r39ASDNkQHMhmbQAAAAAElFTkSuQmCC)
 */
export const BicycleIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M15 4a1 1 0 0 0-.95 1.32l.9 2.68h-4.6l-.92-2.36A1 1 0 0 0 8.5 5H5a1 1 0 0 0 0 2h2.82l.5 1.27a1 1 0 0 0-.2.26L6.7 11.16a4.5 4.5 0 1 0 1.76.95l.78-1.45 1.83 4.7a1 1 0 1 0 1.86-.72L11.13 10h4.48l.55 1.65a4.5 4.5 0 1 0 1.9-.63L16.4 6h1.86c.41 0 .75.34.75.75V7a1 1 0 1 0 2 0v-.25A2.75 2.75 0 0 0 18.25 4H15Zm-9.3 9-1.08 2.03a1 1 0 0 0 1.76.94l1.09-2.01A2.5 2.5 0 1 1 5.7 13Zm11.13.64.72 2.18a1 1 0 0 0 1.9-.64l-.73-2.17a2.5 2.5 0 1 1-1.9.63Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
